import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycHomeTransfersAndRetainedLifeEstatesInNewYorkStatePage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-home-transfers-and-retained-life-estates-in-new-york-state/']} />;
}
